import React from "react";
import { motion } from "framer-motion";
import { Check, ArrowRight, ShieldCheck } from "lucide-react";
import { HERO_FEATURES, IMAGES } from "../data";

export const Hero = () => {
  return (
    <section id="acasa" className="relative overflow-hidden bg-white">
      <div className="absolute inset-0 hero-grid-bg opacity-70" />
      <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-brand-light blur-3xl opacity-60" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-ink leading-[1.08]"
            >
              Contabilitate modernă pentru afaceri care{" "}
              <span className="text-brand">vor să crească.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.16, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-lg text-ink-muted leading-relaxed max-w-xl"
            >
              AN CONTAB AUDIT este membră CECCAR din 2006 și oferă servicii complete
              de contabilitate, fiscalitate și consultanță pentru companii din întreaga
              Românie.
            </motion.p>

            <motion.ul
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.24, ease: [0.22, 1, 0.36, 1] }}
              className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl"
            >
              {HERO_FEATURES.map((f) => (
                <li key={f} className="flex items-center gap-3 text-ink font-medium">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-light">
                    <Check className="h-3.5 w-3.5 text-brand" strokeWidth={3} />
                  </span>
                  {f}
                </li>
              ))}
            </motion.ul>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.32, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col sm:flex-row gap-4"
            >
              <a
                href="#contact"
                data-testid="hero-contact-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-base font-semibold text-white shadow-subtle hover:bg-brand-hover hover:-translate-y-0.5 hover:shadow-lift transition-all duration-300"
              >
                Contactează-ne
                <ArrowRight className="h-5 w-5" />
              </a>
              <a
                href="#servicii"
                data-testid="hero-services-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-7 py-3.5 text-base font-semibold text-ink hover:border-brand hover:text-brand hover:-translate-y-0.5 transition-all duration-300"
              >
                Vezi serviciile
              </a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="relative rounded-[28px] overflow-hidden shadow-lift ring-1 ring-black/5">
              <img
                src={IMAGES.hero}
                alt="Consultanți financiari AN CONTAB AUDIT într-o întâlnire de business"
                className="w-full h-[420px] lg:h-[540px] object-cover"
                loading="eager"
              />
            </div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.55 }}
              className="absolute -bottom-6 -left-6 hidden sm:flex items-center gap-4 rounded-2xl bg-white px-5 py-4 shadow-lift ring-1 ring-black/5"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light">
                <ShieldCheck className="h-6 w-6 text-brand" />
              </div>
              <div>
                <p className="text-2xl font-extrabold text-ink leading-none">99%</p>
                <p className="text-sm text-ink-muted mt-1">clienți mulțumiți</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
